<app-shared-modal
  size="small"
  [open]="open"
  [zIndex]="9999"
  (modalClose)="dismissModal(true)"
>
  <div class="wrapper">
    <h2>🚀 Introducing! Free Buyer List Blasts — SMS & Email, On Us!</h2>

    <div class="content">
      <p>
        Upload up to 20 buyer lists with emails and phone numbers — then
        instantly market your deals to them with FREE SMS + email blasts.
      </p>
      <p>
        That’s 10,000 contacts and $0.<br />No other platform gives you this
        power!
      </p>
    </div>

    <div class="actions">
      <app-shared-button *ngIf="!isLoggedIn" (click)="openAuthModal('signup')">
        Join for free
      </app-shared-button>
      <app-shared-button *ngIf="isLoggedIn" (click)="redirectAction()">
        Upload Lists
      </app-shared-button>
      <app-shared-button theme="tertiary" (click)="dismissModal(true)">
        <span class="font-medium">Don't show again</span>
      </app-shared-button>
    </div>
  </div>
</app-shared-modal>
